import React from 'react'
import PropTypes from 'prop-types'
import { Article, Title, Excerpt, ArticleMeta, MetaItem, MobileMeta, ArticleImage, ArticleContent, ArticlePreview, ImageLinkWrapper } from './ArticleGrid.style'
import Theme from '../../../styles/theme'
import { ARTICLE_SLUG_URL } from '../../../constants/API/url'

const ArticleGrid = ({
  title,
  slug,
  categories,
  featuredImage,
  body,
  publishDate,
}) => (
  <Article>
    <ArticleMeta>
      <MetaItem>{publishDate}</MetaItem>
      <MetaItem>{categories.title}</MetaItem>
    </ArticleMeta>
    <ArticleContent>
      <ArticlePreview>
        <MobileMeta>
          <MetaItem>{publishDate}</MetaItem>
          <MetaItem>{categories.title}</MetaItem>
        </MobileMeta>
        <Title to={ARTICLE_SLUG_URL + slug + '/'}>{title}</Title>
        {body.childMarkdownRemark.rawMarkdownBody && (
          <Excerpt
            dangerouslySetInnerHTML={{
              __html: body.childMarkdownRemark.rawMarkdownBody.replace(/(<([^>]+)>)/ig, '').substring(0, 110),
              // __html: body.childMarkdownRemark.html.replace(/(<([^>]+)>)/ig, '').substring(0, 110),
            }}
          />
        )}
      </ArticlePreview>
      {featuredImage && (
        <ImageLinkWrapper to={`/article/${slug}/`}>
          <ArticleImage
            fluid={featuredImage.imageFile.fluid}
            backgroundColor={Theme.colors.imageBackground}
          />
        </ImageLinkWrapper>
      )}
    </ArticleContent>
  </Article>
)

ArticleGrid.propTypes = {
  slug: PropTypes.string,
  categories: PropTypes.shape({
    title: PropTypes.string,
  }).isRequired,
  featuredImage: PropTypes.shape({
    fluid: PropTypes.object,
  }),
  title: PropTypes.string,
  body: PropTypes.shape({
    childMarkdownRemark: PropTypes.shape({
      rawMarkdownBody: PropTypes.string,
      html: PropTypes.string,
    }),
  }),
  publishDate: PropTypes.string.isRequired,
}

ArticleGrid.defaultProps = {
  slug: null,
  featuredImage: null,
  title: null,
  body: null,
}

export default ArticleGrid
